/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import './src/styles/global.css';
import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
export const wrapRootElement = ({ element }) => {
    return (
        <GoogleReCaptchaProvider useEnterprise={true} reCaptchaKey="6LfSixUrAAAAABXdYW1iMy6adjXH2Yraw8c9blf6"
            scriptProps={{
                async: true
            }}


        >
            {element}
        </GoogleReCaptchaProvider>
    )
}